import React from "react";
import { Stepper, Step, StepLabel, StepConnector, Grid2 } from "@mui/material";
import { styled } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import styles from "./CustomStepper.module.scss";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: "#e0e0e0",
    borderWidth: 2,
  },
  "&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line":
    {
      borderColor: "#1976d2",
    },
  "&.MuiStepConnector-root": {
    top: "9px",
    left: "calc(-50% + 10px)",
    right: "calc(50% + 10px)",
  },
}));

// Steps for the stepper
const steps = ["Account", "Address", "Verification"];

export default function CustomStepper({ activeStep, setActiveStep }) {
  // const handleStepClick = (index) => {
  //   if (index <= activeStep) {
  //     setActiveStep(index);
  //   }
  // };

  return (
    <div className={styles.customStepperContainer}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<CustomConnector />}
        sx={{
          "& .MuiStep-root": {
            paddingLeft: "47px",
            paddingRight: "47px",
          },
          "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
            marginTop: "6px",
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={(props) => {
                const { completed, active } = props;
                return (
                  <Grid2
                    className={`${styles.CustomStepperBox} ${
                      completed || active ? styles.active : ""
                    }`}
                  >
                    <div
                      className={`${styles.customStepIcon} ${
                        completed ? styles.completed : ""
                      } ${active ? styles.active : ""}`}
                    >
                      {completed ? (
                        <CheckCircleIcon />
                      ) : active ? (
                        <div />
                      ) : null}
                    </div>
                  </Grid2>
                );
              }}
              // onClick={() => handleStepClick(index)}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
